import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaBars, FaTimes, FaLeaf } from 'react-icons/fa';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Products', path: '/products' },
    { name: 'Manufacturing', path: '/manufacturing' },
    { name: 'Third-Party', path: '/third-party-manufacturing' },
    { name: 'Quality', path: '/quality' },
    { name: 'Contact', path: '/contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav data-testid="main-navbar" className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3" data-testid="logo-link">
            <img src="/shivangel-logo.png" alt="Shivangel Logo" className="h-14 w-14" />
            <div>
              <h1 className="text-xl font-bold text-[#0F5132]" style={{fontFamily: 'Work Sans'}}>SHIVANGEL</h1>
              <p className="text-xs text-gray-600">Ayurveda & Nutraceuticals</p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-link-${link.name.toLowerCase()}`}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                  isActive(link.path)
                    ? 'bg-[#0F5132] text-white'
                    : 'text-[#0F5132] hover:bg-[#0F5132]/10'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/start-your-brand"
              data-testid="cta-button"
              className="ml-4 px-6 py-2.5 bg-[#0F5132] text-white rounded-lg font-semibold hover:bg-[#0F5132] transition-all duration-200 shadow-md hover:shadow-lg"
            >
              Start Your Brand
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            data-testid="mobile-menu-button"
            className="md:hidden p-2 rounded-lg text-[#0F5132] hover:bg-gray-100"
          >
            {isOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-white border-t border-gray-200" data-testid="mobile-menu">
          <div className="px-4 py-3 space-y-2">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className={`block px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                  isActive(link.path)
                    ? 'bg-[#0F5132] text-white'
                    : 'text-[#0F5132] hover:bg-[#0F5132]/10'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/start-your-brand"
              onClick={() => setIsOpen(false)}
              className="block px-4 py-2.5 bg-[#0F5132] text-white rounded-lg font-semibold text-center"
            >
              Start Your Brand
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;